import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "w-full bg-primary-black text-white pt-32 py-5 lg:px sm:px-10" }
const _hoisted_2 = { class: "max-w-[1366px] mx-auto h-fit lg:px-0 px-10" }
const _hoisted_3 = { class: "flex flex-col lg:flex-row justify-between gap-6" }
const _hoisted_4 = {
  class: "flex-shrink-0",
  href: "https://www.workbean.co/"
}
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("h2", { class: "text-3xl sm:text-[45px] font-normal leading-8 sm:leading-[45px] font-serif max-w-[811px] -mt-2" }, [
  /*#__PURE__*/_createTextVNode(" Ready to uncover your employer brand’s unique voice? "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "https://www.workbean.co/contact-us",
    class: "text-primary-pink font-sans font-semibold block mt-2 sm:mt-0 sm:inline-flex"
  }, "Let’s talk →")
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("hr", { class: "my-[72px] border-[#8D8D8D]" }, null, -1)
const _hoisted_8 = { class: "flex flex-col sm:flex-row lg:justify-between justify-normal gap-3 sm:gap-24 flex-wrap items-start" }
const _hoisted_9 = {
  key: 0,
  class: "normal-case font-light flex flex-col"
}
const _hoisted_10 = ["href"]
const _hoisted_11 = {
  key: 0,
  class: "flex gap-5 py-2 justify-items-center"
}
const _hoisted_12 = ["href"]
const _hoisted_13 = ["src"]
const _hoisted_14 = /*#__PURE__*/_createStaticVNode("<div class=\"max-w-[1366px] mx-auto flex justify-between h-[56px] items-center px-10 mt-10\"><span class=\"text-xs sm:text-xl font-normal mx-auto text-center\">© 2023 Workbean All Rights Reserved<span class=\"block\"><a href=\"https://assets.workbean.co/workbean-documents/Workbean-Privacy-Policy-as-of-7-14-23.pdf\">Privacy Policy</a> | <a href=\"https://assets.workbean.co/workbean-documents/Workbean-Terms-of-Use-as-of-7-14-23.pdf\">Terms</a></span></span></div>", 1)

import { useAssetStore } from "@/store/asset"
  //image
  import FacebookIcon from "@/assets/images/social-media/facebook-icon.svg?inline"
  import InstagramIcon from "@/assets/images/social-media/instagram-icon.svg?inline"
  import YoutubeIcon from "@/assets/images/social-media/youtube-icon.svg?inline"
  import LinkedinIcon from "@/assets/images/social-media/linkedin-icon.svg?inline"

  
export default /*#__PURE__*/_defineComponent({
  __name: 'PageFooter',
  setup(__props) {

  const assetStore = useAssetStore()

  const linkData = [
    {
      title: "Sitemap",
      links: [
        { name: "About Us", url: "https://www.workbean.co/about-us" },
        { name: "Our Work", url: "https://www.workbean.co/our-work" },
        { name: "Services", url: "https://www.workbean.co/services" },
        { name: "Blog", url: "https://www.workbean.co/blogs" },
      ],
    },
    {
      title: "Reach out",
      links: [
        { name: "Project Inquiry", url: "https://www.workbean.co/contact-us" },
        { name: "Join Our Team", url: "" },
      ],
    },
    {
      title: "Singapore",
      links: [{ name: "160 Robinson Road, #14-04 Singapore Business Federation Centre, 068914 Singapore", url: "" }],
    },
    {
      title: "Philippines",
      links: [{ name: "5F Phinma Plaza, Acceler8 by UnionSpace 39, Plaza Dr, Rockwell Center, Makati, 1200 Metro Manila", url: "" }],
    },
  ]
  const links = [
    {
      image: FacebookIcon,
      url: "https://facebook.com/workbean.co",
    },
    {
      image: InstagramIcon,
      url: "https://www.instagram.com/workbean",
    },
    {
      image: LinkedinIcon,
      url: "https://www.linkedin.com/company/myworkbean",
    },
    {
      image: YoutubeIcon,
      url: "https://www.youtube.com/@workbean4779",
    },
  ]

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("a", _hoisted_4, [
          _createElementVNode("img", {
            class: "h-5 sm:h-[26px] sm:flex flex-shrink-0",
            src: `${_unref(assetStore).image}/v4/PNG/horizontal all white.png`,
            alt: "Workbean"
          }, null, 8, _hoisted_5)
        ]),
        _hoisted_6
      ]),
      _hoisted_7,
      _createElementVNode("ul", _hoisted_8, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(linkData, (sections, index) => {
          return _createElementVNode("li", {
            key: `${index}_sections`,
            class: "font-medium mb-5 uppercase text-sm"
          }, [
            _createTextVNode(_toDisplayString(sections.title) + " ", 1),
            (sections.title !== 'Follow Us')
              ? (_openBlock(), _createElementBlock("ul", _hoisted_9, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sections.links, (link, idx) => {
                    return (_openBlock(), _createElementBlock("li", {
                      key: `${idx}_link`,
                      class: "my-1 cursor-pointer text-xs sm:text-xl font-light max-w-[227px]"
                    }, [
                      _createElementVNode("a", {
                        href: link.url,
                        class: _normalizeClass(link.url === '' ? 'pointer-events-none cursor-default' : 'cursor-pointer')
                      }, _toDisplayString(link.name), 11, _hoisted_10)
                    ]))
                  }), 128)),
                  (sections.title === 'Reach out')
                    ? (_openBlock(), _createElementBlock("ul", _hoisted_11, [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(links, (link, idx) => {
                          return _createElementVNode("li", {
                            key: `${idx}_socials`,
                            class: "my-2 cursor-pointer text-base font-normal"
                          }, [
                            _createElementVNode("a", {
                              href: link.url
                            }, [
                              _createElementVNode("img", {
                                src: link.image,
                                alt: "",
                                class: "h-3"
                              }, null, 8, _hoisted_13)
                            ], 8, _hoisted_12)
                          ])
                        }), 64))
                      ]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ])
        }), 64))
      ])
    ]),
    _hoisted_14
  ]))
}
}

})